// @ts-nocheck
import { useState } from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils/cn';


export default function HeadingInfo({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border shadow-sm transition-all',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50',
            open
              ? 'border-primary bg-primary text-primary-foreground shadow-md'
              : 'border-primary/40 bg-primary/10 text-primary hover:scale-110 hover:bg-primary/20 hover:shadow-md',
          )}
        >
          <Info className="h-3 w-3" strokeWidth={2.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        className="w-64 border-primary/20 p-3 text-xs font-normal leading-relaxed"
        onClick={(e) => e.stopPropagation()}
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
